import React from 'react'
import { Link } from 'gatsby'
import FooterNavigationMenu from '../components/footer-navigation-menu'
import styles from './footer.module.scss'


export default () => (
<FooterNavigationMenu />
)
